// source: system/application/views/widgets/moreCategories.php
/**
 * Script for secondary category slider at secondaryCategory.php widget.
 */
$(() => {
    // Variables declaration for use in secondary category slider
    const wrapper = document.querySelector('.cards-wrapper');
    const allCards = document.querySelectorAll('.cards-wrapper .card');
    let lastPixels = 0;
    let visibleCardCount = 4;
    const extraSpaceCount = 5;
    let displayAreaForLastMinus = 5;
    let clickedDotNum = 1;
    let pixels = 0;

    // Catch the next & previous button
    const next = document.querySelector('.slider-action-buttons .next');
    const previous = document.querySelector('.slider-action-buttons .previous');

    // Hide the previous button by default - FIXED: Check for null, not just undefined
    if (previous && clickedDotNum === 1) {
        previous.classList.add("hidden-element");
    }

    // Hide the next button on condition - FIXED: Check for null
    if (next && (allCards.length < visibleCardCount || clickedDotNum === (allCards.length - visibleCardCount))) {
        next.classList.add("hidden-element");
    }

    // On click previous button event handler - FIXED: Check for null
    if (previous) {
        previous.addEventListener('click', (e) => {
            const displayArea = allCards[0].clientWidth + extraSpaceCount;
            if (clickedDotNum === 0) {
                return;
            }
            clickedDotNum--;
            pixels = -displayArea * clickedDotNum;
            wrapper.style.transform = `translateX(${pixels}px)`;
            if (clickedDotNum === 0) {
                previous.classList.add("hidden-element");
                clickedDotNum++;
            }
            next.classList.remove("hidden-element");
            updateCarouselStatus();
        });
    }

    // On click next button event handler - FIXED: Check for null
    if (next) {
        next.addEventListener('click', (e) => {
            if (wrapper.clientWidth < 570) {
                visibleCardCount = 3;
                displayAreaForLastMinus = 4;
            }
            if (wrapper.clientWidth < 500) {
                visibleCardCount = 2;
                displayAreaForLastMinus = 3;
            }

            // To hide the extra space  
            let displayArea = allCards[0].clientWidth + extraSpaceCount;
            if (clickedDotNum === (allCards.length - visibleCardCount)) {
                displayArea = allCards[0].clientWidth + extraSpaceCount;
                const displayAreaForLast = (displayArea * displayAreaForLastMinus) - wrapper.clientWidth;
                next.classList.add("hidden-element");
                pixels = (lastPixels - displayAreaForLast);
                wrapper.style.transform = `translateX(${pixels}px)`;
                updateCarouselStatus();
                return;
            } else {
                if (previous) previous.classList.remove("hidden-element");
                pixels = (-displayArea * clickedDotNum);
                wrapper.style.transform = `translateX(${pixels}px)`;
                lastPixels = pixels;
                clickedDotNum++;
            }
            updateCarouselStatus();
        });
    }

    // Keyboard navigation support for accessibility
    const carouselContainer = document.querySelector('.display-area');
    const statusElement = document.getElementById('carousel-status');
    
    if (carouselContainer) {
        carouselContainer.addEventListener('keydown', (e) => {
            let handled = false;
            
            switch(e.key) {
                case 'ArrowLeft':
                    if (previous && !previous.classList.contains('hidden-element')) {
                        previous.click();
                        handled = true;
                    }
                    break;
                case 'ArrowRight':
                    if (next && !next.classList.contains('hidden-element')) {
                        next.click();
                        handled = true;
                    }
                    break;
                case 'Home':
                    // Go to first slide
                    if (clickedDotNum > 1) {
                        while (clickedDotNum > 1 && previous && !previous.classList.contains('hidden-element')) {
                            previous.click();
                        }
                        handled = true;
                    }
                    break;
                case 'End':
                    // Go to last slide
                    while (next && !next.classList.contains('hidden-element')) {
                        next.click();
                    }
                    handled = true;
                    break;
            }
            
            if (handled) {
                e.preventDefault();
                updateCarouselStatus();
            }
        });
    }
    
    // Function to update carousel status for screen readers
    function updateCarouselStatus() {
        if (statusElement && allCards.length > 0) {
            const totalSlides = Math.ceil(allCards.length / visibleCardCount);
            const currentSlide = Math.max(1, clickedDotNum);
            statusElement.textContent = `Showing slide ${currentSlide} of ${totalSlides}`;
        }
    }
    
    // Update status on initial load
    updateCarouselStatus();
    
    // Main banner carousel keyboard navigation
    const mainBannerCarousel = document.getElementById('main-banner-carousel');
    const bannerStatusElement = document.getElementById('banner-carousel-status');
    
    if (mainBannerCarousel) {
        // Add keyboard navigation
        mainBannerCarousel.addEventListener('keydown', (e) => {
            let handled = false;
            
            switch(e.key) {
                case 'ArrowLeft':
                    $(mainBannerCarousel).carousel('prev');
                    handled = true;
                    break;
                case 'ArrowRight':
                    $(mainBannerCarousel).carousel('next');
                    handled = true;
                    break;
                case 'Home':
                    $(mainBannerCarousel).carousel(0);
                    handled = true;
                    break;
                case 'End':
                    const totalSlides = mainBannerCarousel.querySelectorAll('.item').length;
                    $(mainBannerCarousel).carousel(totalSlides - 1);
                    handled = true;
                    break;
            }
            
            if (handled) {
                e.preventDefault();
            }
        });
        
        // Update status when slide changes
        $(mainBannerCarousel).on('slid.bs.carousel', function(e) {
            updateBannerCarouselStatus();
        });
        
        // Pause carousel on focus/hover for accessibility
        mainBannerCarousel.addEventListener('mouseenter', () => {
            $(mainBannerCarousel).carousel('pause');
        });
        
        mainBannerCarousel.addEventListener('mouseleave', () => {
            if (!document.querySelector(':focus-within')) {
                $(mainBannerCarousel).carousel('cycle');
            }
        });
        
        mainBannerCarousel.addEventListener('focusin', () => {
            $(mainBannerCarousel).carousel('pause');
        });
        
        mainBannerCarousel.addEventListener('focusout', () => {
            if (!mainBannerCarousel.matches(':hover')) {
                $(mainBannerCarousel).carousel('cycle');
            }
        });
    }
    
    // Function to update banner carousel status for screen readers
    function updateBannerCarouselStatus() {
        if (bannerStatusElement && mainBannerCarousel) {
            const activeSlide = mainBannerCarousel.querySelector('.item.active');
            const allSlides = mainBannerCarousel.querySelectorAll('.item');
            const currentIndex = Array.from(allSlides).indexOf(activeSlide) + 1;
            const totalSlides = allSlides.length;
            
            // Update aria-selected attributes
            allSlides.forEach((slide, index) => {
                slide.setAttribute('aria-selected', slide === activeSlide ? 'true' : 'false');
            });
            
            if (activeSlide) {
                const slideTitle = activeSlide.querySelector('img')?.alt || `Slide ${currentIndex}`;
                bannerStatusElement.textContent = `${slideTitle}, slide ${currentIndex} of ${totalSlides}`;
            }
        }
    }
    
    // Update banner status on initial load
    updateBannerCarouselStatus();
});